import { render, staticRenderFns } from "./PageSelectItem.vue?vue&type=template&id=275966d0&"
import script from "./PageSelectItem.vue?vue&type=script&lang=ts&"
export * from "./PageSelectItem.vue?vue&type=script&lang=ts&"
import style0 from "./PageSelectItem.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports